import React, { useState, useEffect, useContext } from 'react';
import { Modal } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import { Switch } from 'antd';

import { DataContext } from '../../../init/getData';

import Select from 'react-select';

import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import  { exportedVisibleDevTabs } from '../../../devTab/devRole/crud/tabsPermission';

const TabsPermission = (props) => {

  const { api, userData } = useContext(DataContext);
  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role.name;

  const { showModal, toggleModal, refreshTable, tittle, idRow } = props;

  const [loadingEffect, setLoadingEffect] = useState(false);
 
  const [settings, setSettings] = useState({});


  useEffect(() => {
    if (idRow) {
      setSettings(
        {
          accountTab: idRow.accountTab,
          transactionsTab: idRow.transactionsTab,
          membershipTab: idRow.membershipTab,
          reportTab: idRow.reportTab,
          latestMembershipTab: idRow.latestMembershipTab,
          settingTab: idRow.settingTab,

          accountTabVisibility: idRow.accountTabVisibility,
          transactionsTabVisibility: idRow.transactionsTabVisibility,
          membershipTabVisibility: idRow.membershipTabTabVisibility,
          reportTabVisibility: idRow.reportTabVisibility,
          latestMembershipTabVisibility: idRow.latestMembershipTabTabVisibility,
          settingTabVisibility: idRow.settingTabVisibility,
      
         
          
       
        }
      )

    }
  }, [idRow]);

  const handleSubmit = async () => {
    setLoadingEffect(true);

    const id = idRow.id;

    let res = await api.post(`/role/editPermissions`, JSON.stringify({ id, settings }))
    if (res.data.status) {
      toast.success(res.data.message);
      refreshTable();
      toggleModal(); 
    }
    else {
      toast.error(res.data.message);
    }

    setLoadingEffect(false);
  }

  const handleChange = (name, value) => {
    setSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  

  return (
    <Modal show={showModal} backdrop="static" size='md' onHide={toggleModal} >
      <Modal.Header style={{ background: "#1f2939" }}>
        <Modal.Title style={{ color: "white" }}>{idRow.name} Tabs Permissions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form style={{ marginBottom: '10%', marginTop: '5%', alignItems: 'center' }}>

          
        
                    <Form.Group as={Row} className="mb-9">
                      <Form.Label column sm={5}>Account Tab </Form.Label>
                      <Switch defaultChecked onChange={(e) => handleChange('accountTab', e)} checked={settings.accountTab} />
                    </Form.Group>
          

         
                    <Form.Group as={Row} className="mb-9">
                      <Form.Label column sm={5}>Transactions Tab </Form.Label>
                      <Switch defaultChecked onChange={(e) => handleChange('transactionsTab', e)} checked={settings.transactionsTab} />
                    </Form.Group>
          
            
          
                    <Form.Group as={Row} className="mb-9">
                      <Form.Label column sm={5}>Membership Tab </Form.Label>
                      <Switch defaultChecked onChange={(e) => handleChange('membershipTab', e)} checked={settings.membershipTab} />
                    </Form.Group>
           
                
                  

        
                    <Form.Group as={Row} className="mb-9">
                      <Form.Label column sm={5}>Reports Tab</Form.Label>
                      <Switch defaultChecked onChange={(e) => handleChange('reportTab', e)} checked={settings.reportTab} />
                    </Form.Group>
        

   
                    <Form.Group as={Row} className="mb-9">
                      <Form.Label column sm={5}>Latest Membership Tab</Form.Label>
                      <Switch defaultChecked onChange={(e) => handleChange('latestMembershipTab', e)} checked={settings.latestMembershipTab} />
                    </Form.Group>
       

           
                    <Form.Group as={Row} className="mb-9">
                      <Form.Label column sm={5}>Latest Membership Tab</Form.Label>
                      <Switch defaultChecked onChange={(e) => handleChange('settingTab', e)} checked={settings.settingTab} />
                    </Form.Group>
       
     

     
   


          <Form.Group as={Row} className="mb-9">

          </Form.Group>






        </Form>


        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={toggleModal}>
            Close
          </button>

          <button type="button" className="btn btn-primary" onClick={handleSubmit}>
            Save Data
          </button>

          {loadingEffect && (
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          )}

        </div>


      </Modal.Body>
    </Modal>
  )
}


export default TabsPermission;